import React, { useEffect, useRef, useContext, useState } from "react";
import AuthClient from "../../../api/AuthClient";
import "../promotersPages.scss";
import Gender from "../../../api/enums/Gender";
import { getUserAvatar } from "../../../utils/getMedia";
import { DateFormat, formatDate, formateDateForPromoterGroups } from "../../../utils/datePareser";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ApiResponse } from "../../../api/responses/AxiosResponseHandler";
import { SelectedGroupContext } from "../../../GlobalContext/groupDetailContext";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../routes/routes";
import RefreshButton from "../../RefreshToUpdateData/RefreshToUpdateButton";
import { PartyModel } from "../../../types";
import OpenClubsForPromoterGroupApi from "../../../api/OpenClubsForPromoterGroupApi";
import { PromoterGroupOpenClubsApiResponse } from "../../../api/responses/PromoterGroupOpenClubsApiResponse";
import { parseOpenClubsResponse } from "../../../api/parseResponse/parsePromoterGroupOpenClubsResponse";
import { OpenClubsContext } from "../../../GlobalContext/openClubsContext";
import { PromoterGroupsContext } from "../../../GlobalContext/promoterGroupsContext";
import { filterGroupsByMinimumAge } from "../../../utils/utils";
import PromoterGroupGenderCounts from "../../PromoterGroups/PromoterGroupGenderCounts";
import handleImgError from "../../../handleImgError";

interface Props {
    authClient: AuthClient;
}
const PromoterNewTab: React.FC<Props> = ({ authClient }) => {

    const { groups, requestState, errorMessage, fetchGroups, seenGroupIds, markSeen } =
        useContext(PromoterGroupsContext);
    const [minimumAge, setMinimumAge] = useState<number | "">("");
    const showToastRef = useRef(false);
    const navigate = useNavigate();
    const { setSelectedGroup } = useContext(SelectedGroupContext);
    const { setPromoterGroupOpenClubs } = useContext(OpenClubsContext);

    // Seen-Unseen groups handler.
    const handleSeenGroup = (group: PartyModel): void => {

        const selectedGroup = groups.find(
            (newSeenGroup) => newSeenGroup.party.id === group.party.id,
        );

        const openClubsAPI = new OpenClubsForPromoterGroupApi(authClient);

        if (selectedGroup) {
            openClubsAPI.getPromoterGroupOpenClubs(selectedGroup.party.city, selectedGroup.party.partyDate, selectedGroup.party.bookingType.toString(), selectedGroup.promotersOffers[0]?.promoter?.id).then((clubs) => {

                const response: ApiResponse<PromoterGroupOpenClubsApiResponse> | undefined = clubs;
                const parsedOpenClubs = parseOpenClubsResponse(response?.data?.openClubs);

                if (parsedOpenClubs.openClubs) {
                    setPromoterGroupOpenClubs(parsedOpenClubs.openClubs);
                }
            });
        }

        if (group.party.partyDate && group.party.id) {
            markSeen(group.party.id, group.party.partyDate);
        }

        if (selectedGroup) {
            setSelectedGroup(selectedGroup);
        } else {
            console.log("No matching group found for the selected invitation");
        }
    };

    const newUnSeenGroups = groups.length > 0
        ? groups.filter((g) => !seenGroupIds.some((s) => s.id === g.party.id))
        : [];

    const filteredNewGroups = filterGroupsByMinimumAge(newUnSeenGroups, minimumAge);

    // Showing Api Response error message.
    useEffect(() => {
        if (errorMessage && !showToastRef.current) {
            showToastMessage(errorMessage);
            showToastRef.current = true;
        }
    }, [errorMessage]);

    const showToastMessage = (error: string) => {
        toast.error("Something went wrong!", {
            position: toast.POSITION.TOP_CENTER
        });
    };

    // Formatting date.
    const formattedDate = (inputDateString: Date, inCludeTime: boolean) => {
        const date = new Date(inputDateString);
        return formatDate(date, inCludeTime, DateFormat.Short);
    }

    const handleButtonClick = () => {
        fetchGroups();
    };

    const openGroupDetail = (group: PartyModel) => {
        handleSeenGroup(group);
        navigate(routes.PromGroupDetailPage(group.party.city, group.party.id));
    };

    const minimumAgeOptions = Array.from({ length: 8 }, (_, index) => 18 + index);

    return (
        <>
            <div className="input-group mb-3 ageInputContainer ">
                <select
                    className="form-control shadow-none ageInput"
                    aria-label="Minimum Age"
                    aria-describedby="basic-addon1"
                    value={minimumAge}
                    onChange={(event) => {
                        const value = event.target.value === "" ? "" : Number(event.target.value);
                        setMinimumAge(value);
                    }}
                >
                    <option value="">Minimum age (any)</option>
                    {minimumAgeOptions.map((age) => (
                        <option key={age} value={age}>
                            {age}
                        </option>
                    ))}
                </select>
            </div>
            <div className="mb-3 refreshRequestContainer">
                <RefreshButton requestState={requestState} onClickHandler={handleButtonClick} />
            </div>
            {filteredNewGroups.length > 0 ? (
                <div>
                    {filteredNewGroups.map((group) => (

                        <div
                            className="groupPromoter"
                            key={group.party.id}
                            role="button"
                            tabIndex={0}
                            onClick={() => openGroupDetail(group)}
                            onKeyDown={(event) => {
                                if (event.key === "Enter" || event.key === " ") {
                                    event.preventDefault();
                                    openGroupDetail(group);
                                }
                            }}
                        >
                            {/*Date of the group */}
                            <div className="datePm d-flex align-items-center w-100">
                                <p> {formateDateForPromoterGroups(group.party.partyDate)} </p>
                            </div>

                            {/* Group detail section starts */}
                            <div className="text-center row align-items-start promoter-new__summary-row">
                                <div className="guestListTitle greyBorder col">
                                    <p className="mt-2">{group.party.bookingType}</p>
                                </div>
                                <PromoterGroupGenderCounts invitations={group.invitations} />
                                <div className="dateCreated greyBorder d-flex flex-column col">
                                    <p>Created</p>
                                    <p>
                                        {formattedDate(group.party.createdAt, true)}
                                    </p>
                                </div>
                            </div>
                            <div className="text-center row mt-2 agesGroup promoter-new__ages-row">
                                <span className="d-flex fw-semibold col-auto">Ages:&nbsp;</span>
                                <span className="d-flex yellowTxt col-auto p-0 ageP promoter-new__ages-values gap-1">
                                    {group.invitations.map((invitation) => (
                                        <span key={invitation.id} className="badge text-bg-dark">{invitation.age}</span>
                                    ))}
                                </span>
                            </div>
                            <div className="yellowTxt promoter-avatar-row">
                                {group.invitations.map((invitation) => (
                                    <Link
                                        to={routes.PromGroupPhotosPage(group.party.city, group.party.id)}
                                        key={invitation.id}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            handleSeenGroup(group);
                                        }}
                                        className="promoter-avatar-row__link"
                                    >
                                        <img
                                            src={getUserAvatar(invitation?.id!)}
                                            alt="Profile Image"
                                            className="imgGuest promoter-avatar-row__image"
                                            onError={(event) =>
                                                handleImgError(
                                                    event,
                                                    typeof invitation.gender === "string"
                                                        ? invitation.gender
                                                        : Gender[invitation.gender]
                                                )
                                            }
                                        />
                                    </Link>
                                ))}
                            </div>
                            <div className="mt-2 row">
                                <span className="d-flex fw-semibold col-auto">Requested:&nbsp;</span>
                                <span className="d-flex col-auto yellowTxt p-0 ageP gap-1 ">
                                    {group.requestedListings.map((listing) => (
                                        <span key={listing.id} className="badge text-bg-dark">{listing.clubName}</span>
                                    ))}
                                </span>
                            </div>
                            {group.promotersOffers.length > 0 ?
                                <div className="mt-2 row">
                                    <span className="d-flex fw-semibold col-auto">Sent:</span>
                                    <span className="d-flex col-auto yellowTxt p-0 ageP gap-1">
                                        {group.promotersOffers.flatMap((listing) => listing.offers).map((offer) => (
                                            <span key={offer.id} className="badge text-bg-dark">{offer.clubName}</span>
                                        ))}
                                    </span>
                                </div> : ""
                            }

                            {/* Group detail section end */}

                        </div>
                    ))}
                </div >
            ) : requestState === 'loading' ? null : (
                <div className="container text-center newTabContent">
                    <p>
                        There are currently no groups that you have not seen looking to go out
                        in London. You will be notified when new groups are created.
                    </p>
                    <p>
                        The groups you have already looked at can now be found on the Seen
                        tab.
                    </p>
                    <ToastContainer
                        progressClassName="toastProgress"
                        bodyClassName="toastBody"
                    />
                </div>
            )}
        </>
    );
};

export default PromoterNewTab;

